import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-confirm-password',
  templateUrl: './confirm-password.component.html',
  styleUrls: ['./confirm-password.component.scss']
})
export class ConfirmPasswordComponent implements OnInit {

  @Input() form;
  @Input() controlName;
  @Input() disabled;
  @Input() required;
  @Input() value;
  @Input() label;
  @Input() float_label;
  @Input() placeholder;
  @Input() type;
  @Input() field_obj;
  @Input() maxlength;
  @Input() minlength;
  confirmPasswordForm = new FormGroup({
    password: new FormControl(''),
    confirmpassword: new FormControl(''),
  }, {
    validators: this.PasswordValidator.bind(this)
  });
  constructor() { }

  ngOnInit(): void {
    if (this.form.value[this.controlName]) {
      this.confirmPasswordForm.get('password').setValue(this.form.value[this.controlName]);
      this.confirmPasswordForm.get('confirmpassword').setValue(this.form.value[this.controlName]);
    }
  }

  PasswordValidator(formGroup: FormGroup) {
    const { value: password } = formGroup.get('password');
    const { value: confirmPassword } = formGroup.get('confirmpassword');
    return password === confirmPassword ? null : { passwordNotMatch: true };
  }

  transformFn(controlName, transform) {
    if ((controlName).value) {
      if (transform == 1) {
        controlName.setValue((controlName.value).toUpperCase())
      }
      else if (transform == 2) {
        controlName.setValue((controlName.value).toLowerCase())
      }
    }
  }

  checkValidity() {
    if (!(this.confirmPasswordForm.errors && this.confirmPasswordForm.errors.passwordNotMatch && (this.confirmPasswordForm.get('password').invalid) && (this.confirmPasswordForm.get('confirmpassword').invalid))) {
      this.form.get(this.controlName).patchValue(this.confirmPasswordForm.get('password').value)
    }
  }

}
